<div class="trophies-list">
  <ng-container *ngIf="items.length > 0; else placeholders">
    <div class="trophies-list__item" *ngFor="let item of items">
      <brt-trophies-list-item [item]="item"></brt-trophies-list-item>
    </div>
  </ng-container>
  <ng-template #placeholders>
    <div class="trophies-list__item trophies-list__item--placeholder" *ngFor="let item of [].constructor(6)">
      <div class="trophies-list__item-placeholder">
        <img class="skeleton-desktop" src="/assets/img/Trophy-ITEM.svg" alt=""/>
        <img class="skeleton-mobile" src="/assets/img/Trophy-mobile-ITEM.svg" alt=""/>
      </div>
    </div>
  </ng-template>

</div>
